<div class="dialog-header">
  <h6 matDialogTitle>{{ privacyHeader }}</h6>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div style="height: 420px" [innerHTML]="privacyMessage"></div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <div class="pull-right" style="margin: 1em">
    <button
      id="loginbtn"
      type="button"
      bciprimarybutton
      class="button-primary"
      (click)="accept()"
      [disabled]="firstLogin"
    >
      Accept
    </button>
    &nbsp;
    <button
      id="cancelbtn"
      type="button"
      bciprimarybutton
      class="button-primary"
      (click)="close(false)"
      [disabled]="firstLogin"
    >
      Cancel
    </button>
  </div>
</mat-dialog-footer>
